import { render, staticRenderFns } from "./WaToast.vue?vue&type=template&id=24fa61c8"
import script from "./WaToast.vue?vue&type=script&lang=js"
export * from "./WaToast.vue?vue&type=script&lang=js"
import style0 from "./WaToast.vue?vue&type=style&index=0&id=24fa61c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports